import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Intl from 'src/components/Intl';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

function Header() {
  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root>
            <Logo src={require('src/assets/images/logo.svg')} alt="logo" />
            <ButtonWrapper>
              
              <RegisterButton>
                <a href="#register">{t.header.button}</a>
              </RegisterButton>
            </ButtonWrapper>
            <Slogan>{t.header.slogan}
            
            <SubNav locale={locale}>
                {
                  console.log(locale)
                }
                <Link to={'/'}>EN</Link>
                <Link to={'/zh-tc'}>繁</Link>
                <Link to={'/zh-sc'}>简</Link>
                <Link to={'/kr'}>한국어</Link>
                <Link>{t.header.button}</Link>
              </SubNav>
            </Slogan>
            
          </Root>
        );
      }}
    </Intl>
  );
};

export default Header;

const Root = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
 
  background-color: white;
  z-index: 99;

  @media ${media.desktop} {
    align-items: left;
   
  }
`;

const Logo = styled.img`
  position: absolute;
  top: 0px;
  ${vw('width', 80, 126)}
  ${vw('height', 140, 221)}
  ${vw('left', 10, 35, 100)}
`;

const Slogan = styled.p`
  font-family: Gotham Bold;
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  color: #000000;
  ${vw('font-size', 14, 20)}
  ${vw('line-height', 15, 40)}
  ${vw('letter-spacing', -1, 1)}
  ${vw('margin-left', 101, 191, 256)}
  ${vw('margin-top', 50, 65, 6)}
  ${vw('margin-bottom', 8, 8, 4)}

  br {
    @media ${media.tablet} {
      display: none;
    }
  }
`;

const ButtonWrapper = styled.div`
  position: fixed;
  top:0;
  right:0;
  display: flex;
  z-index:9999;
`;

const SubNav = styled.nav`
  position: absolute;
  align-items: center;
  margin-right: 20px;
  ${vw('top', -40, -2)}
${vw('right', 70, 0)}
  > a {  
    font-family: Gotham Book;
    font-style: normal;
    font-weight: bold;
   
    ${vw('font-size', 9, 12)}
    line-height: 11px;
    text-transform: capitalize;
    color: gray;

    &:not(:first-of-type) {
    
      ${vw('margin-left', 14, 15)}
    }

    &:first-of-type {
      color: ${props => props.locale === '' || props.locale === 'en' && '#DE5647'};
    }

    &:nth-of-type(2) {
      color: ${props => props.locale === 'zh-tc' && '#DE5647'};
    }

    &:nth-of-type(3) {
      color: ${props => props.locale === 'zh-sc' && '#DE5647'};
    }

    &:nth-of-type(4) {
      color: ${props => props.locale === 'kr' && '#DE5647'};
    }
    &:nth-of-type(5) {
      opacity:0;
      ${vw('padding-left', 17, 40)}
      ${vw('padding-right', 17, 22)}
      text-transform: uppercase;
    }
  }
`;

const RegisterButton = styled.nav`
  > a {
    display: block;
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    text-transform: capitalize;
    color: #000000;
    cursor: pointer;
    ${vw('font-size', 9, 12)}
    ${vw('line-height', 9, 11)}
    ${vw('padding-top', 11, 17)}
    ${vw('padding-bottom', 11, 17)}

    &:first-of-type {
      /* ${vw('margin-right', 17, 46)} */
    }

    &:last-of-type {
      font-family: Sharp Sans TRIAL;
      font-weight: bold;
      text-transform: uppercase;
      color: #FFFFFF;
      background: #DE5647;
      ${vw('font-size', 9, 12)}
      ${vw('line-height', 12, 16)}
      ${vw('letter-spacing', 0.72)}
      ${vw('padding-left', 17, 40)}
      ${vw('padding-right', 17, 40)}
    }

    &:not(:first-of-type):not(:last-of-type) {
      display: none;

      @media ${media.tablet} {
        display: block;
        ${vw('margin-right', 17, 37)}
      }
    }
  }
`;